import { render, staticRenderFns } from "./form-record-list.vue?vue&type=template&id=168bbb98&scoped=true&"
import script from "./form-record-list.vue?vue&type=script&lang=js&"
export * from "./form-record-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168bbb98",
  null
  
)

export default component.exports